import React from "react"
import { Link } from "gatsby"

import Layout from '../../components/layout'
import Seo from '../../components/seo'

import '../css/article.css'
//import images
import msg2 from '../../images/cicada-3301/cicada_msg2.png'
import img2 from '../../images/cicada-3301/cicada_img2.png'
import img3 from '../../images/cicada-3301/cicada_img3.png'
import logo1 from '../../images/cicada-3301/cicada_logo1.png'
import msg1 from '../../images/cicada-3301/cicada_msg1.png'
import msg3 from '../../images/cicada-3301/cicada_msg3.png'

import robot from '../../images/robot.png'
import bat from '../../images/bat.png'

const IndexPage = () => {
 
  return  (
<Layout>
    <Seo 
    title="Mystery of Cicada 3301- CICADA|SKTUTS"
     description="Hope all of you love to solve puzzles and to know more about about the biggest unsolved puzzle available on the internet the Cicada 3301"
      keywords="cicada 3301,    cicada 3301 puzzle,    cicada 3301 solved,    cicada 3301 website,    what is cicada 3301,    cicada 3301 liber primus,    cicada 3301 book,    cicada 3301 puzzle 2018,    cicada 3301 twitter,    cicada 3301 wiki,    cicada 3301 first puzzle,    cicada 3301 music,    cicada 3301 phone number,    cicada 3301 movie,    cicada 3301 original post,    who is cicada 3301,    cicada 3301 an internet mystery,    cicada 3301 images,    cicada 3301 documentary,    cicada 3301 locations,    cicada 3301 original image,    cicada 3301 book pdf,    cicada 3301 puzzle 2017,    cicada 3301 video,    cicada 3301 3rd puzzle,    cicada 3301 clues,    cicada 3301 game,    cicada 3301 message,    cicada 3301 puzzle 2012,    cicada 3301 puzzle solved,    cicada 3301 qr code,    cicada 3301 solution,    cicada 3301 website 2018,    cicada 3301 test questions,    cicada 3301 ring,    cicada 3301 liber primus pdf,    cicada 3301 all puzzles,    cicada 3301 an internet mystery music,    cicada 3301 challenge, cicada 3301 duck,    cicada 3301 link,    cicada 3301 test,    cicada 3301 wallpaper,    cicada 3301 website link,    how to join cicada 3301,    how to solve cicada 3301,    3301 cicada 2016,    3301 cicada 2017,    answer to cicada 3301,    cicada 3301 14 march 2016,    cicada 3301 14. märz,    cicada 3301 17 years,    cicada 3301 1st puzzle,    cicada 3301 2,    cicada 3301 2k18,    cicada 3301 2nd puzzle,    cicada 3301 3,    cicada 3301 3 rätsel,    cicada 3301 4,    cicada 3301 4chan,    cicada 3301 4chan 2012,    cicada 3301 4chan 2018,    cicada 3301 4chan archive,    cicada 3301 4chan post,    cicada 3301 4chan thread,    cicada 3301 4th puzzle,    cicada 3301 58 pages,    cicada 3301 7,    cicada 3301 adalah,    cicada 3301 alphabet,    cicada 3301 and anonymous,    cicada 3301 and bitcoin,    cicada 3301 answer,    cicada 3301 apocalypse song,    cicada 3301 april 18 2018,    cicada 3301 april 18th 2018,    cicada 3301 arg, cicada 3301 article,    cicada 3301 audio,    cicada 3301 bbc,    cicada 3301 beginning,    cicada 3301 berkeley,    cicada 3301 bitcoin,    cicada 3301 book cipher,    cicada 3301 book code,    cicada 3301 book puzzle,    cicada 3301 book solved,    cicada 3301 cia,    cicada 3301 cipher,    cicada 3301 clue 1,    cicada 3301 code,    cicada 3301 coordinates,    cicada 3301 cracked,    cicada 3301 creator,    cicada 3301 current puzzle,    cicada 3301 cyberpunk,    cicada 3301 dark web,    cicada 3301 debunked,    cicada 3301 decoded,    cicada 3301 deep web,    cicada 3301 deprogramming,    cicada 3301 discord server,    cicada 3301 disk image,    cicada 3301 download,    cicada 3301 duck url,    cicada 3301 edinburgh fringe,    cicada 3301 edinburgh fringe review,    cicada 3301 edinburgh review,    cicada 3301 email,    cicada 3301 ending,    cicada 3301 enigmas,    cicada 3301 epiphany is upon you,    cicada 3301 episode 3,    cicada 3301 episode 4,    cicada 3301 explained,    cicada 3301 exposed,    cicada 3301 fandom,    cicada 3301 film,    cicada 3301 final message,    cicada 3301 final.jpg,    cicada 3301 finger ring,    cicada 3301 first image,    cicada 3301 font,    cicada 3301 forum,    cicada 3301 founder,    cicada 3301 fringe,    cicada 3301 game download,    cicada 3301 gematria,    cicada 3301 gematria primus,    cicada 3301 gif,    cicada 3301 github,    cicada 3301 great big story,    cicada 3301 group,    cicada 3301 guitar,    cicada 3301 guitar tab,    cicada 3301 hackers,    cicada 3301 hash,    cicada 3301 hawaii,    cicada 3301 hd wallpaper,    cicada 3301 hindi,    cicada 3301 history,    cicada 3301 hoax,    cicada 3301 hoodie,    cicada 3301 how to play,    cicada 3301 how to start,    cicada 3301 image solved,    cicada 3301 in hindi,    cicada 3301 in lucifer,    cicada 3301 in lucifer movie,    cicada 3301 in malayalam,    cicada 3301 interconnectedness,    cicada 3301 interconnectedness tab,    cicada 3301 internet mystery,    cicada 3301 irc,    cicada 3301 january 2018,    cicada 3301 january 2019,    cicada 3301 joel,    cicada 3301 jogar,    cicada 3301 jogo,    cicada 3301 join,    cicada 3301 juego,    cicada 3301 jugar,    cicada 3301 kas tai,    cicada 3301 kaskus,    cicada 3301 key,    cicada 3301 killer,    cicada 3301 know your meme,    cicada 3301 knowledge,    cicada 3301 koan,    cicada 3301 korea,    cicada 3301 last puzzle,    cicada 3301 latest news,    cicada 3301 lemmino,    cicada 3301 liber primus solved,    cicada 3301 like,    cicada 3301 like puzzles,    cicada 3301 logo,    cicada 3301 lucifer,    cicada 3301 malayalam,    cicada 3301 malayalam meaning,    cicada 3301 manifesto,    cicada 3301 marcus wanner,    cicada 3301 meaning,    cicada 3301 members,    cicada 3301 music download,    cicada 3301 nedir,    cicada 3301 netflix,    cicada 3301 new orleans,    cicada 3301 new puzzle,    cicada 3301 new puzzle 2019,    cicada 3301 news,    cicada 3301 next puzzle,    cicada 3301 nox populi,    cicada 3301 number,    cicada 3301 occult,    cicada 3301 online,    cicada 3301 operating system,    cicada 3301 organization,    cicada 3301 original image download,    cicada 3301 original picture,    cicada 3301 os,    cicada 3301 outguess,    cicada 3301 part 1,    cicada 3301 part 3,    cicada 3301 pdf,    cicada 3301 pgp key,    cicada 3301 pierwsza zagadka,    cicada 3301 puzzle 1,    cicada 3301 puzzle 2019,    cicada 3301 puzzle 3,    cicada 3301 puzzle 4,    cicada 3301 puzzle 4chan,    cicada 3301 puzzle questions,    cicada 3301 puzzle website,    cicada 3301 puzzles and answers,    cicada 3301 qr,    cicada 3301 qr code locations,    cicada 3301 que es,    cicada 3301 quest,    cicada 3301 questions,    cicada 3301 quora,    cicada 3301 quotes,    cicada 3301 real image,    cicada 3301 recruitment,    cicada 3301 reddit,    cicada 3301 review,    cicada 3301 riddle,    cicada 3301 ringtone,    cicada 3301 rolling stone,    cicada 3301 rune book, cicada 3301 rune key, cicada 3301 runes, cicada 3301 rätsel 1, cicada 3301 second puzzle, cicada 3301 secret, cicada 3301 similar, cicada 3301 similar puzzles, cicada 3301 site, cicada 3301 song, cicada 3301 sta je, cicada 3301 subreddit, cicada 3301 sydney, cicada 3301 symbol, cicada 3301 t shirt, cicada 3301 tattoo, cicada 3301 text, cicada 3301 the instar emergence, cicada 3301 the instar emergence tab, cicada 3301 third puzzle, cicada 3301 theories, cicada 3301 timeline, cicada 3301 third year, cicada 3301 underbelly, cicada 3301 uncovering, cicada 3301 unsolved puzzle, cicada 3301 unsolved, cicada 3301 update 2018, cicada 3301 update, cicada 3301 urban dictionary, cicada 3301 update 2019, cicada 3301 vice, cicada 3301 url, cicada 3301 viki, cicada 3301 video music, cicada 3301 virus, cicada 3301 vikipedija, cicada 3301 voicemail, cicada 3301 voce sabia, cicada 3301 vs anonymous, cicada 3301 voltou, cicada 3301 website 2019, cicada 3301 wallpaper hd, cicada 3301 who are you, cicada 3301 where to start, cicada 3301 wikipedia malayalam, cicada 3301 wikipedia, cicada 3301 xyz, cicada 3301 youtube, cicada 3301 z, cicada 3301 zagadki, cicada and 3301, how cicada 3301 was solved, how did cicada 3301 end, how did cicada 3301 start, how many cicada 3301 puzzles are there,    how to access cicada 3301,    how to play cicada 3301,    how to solve cicada 3301 puzzle,    how to start cicada 3301,    is cicada 3301 an arg,    is cicada 3301 dangerous,    is cicada 3301 safe,    is cicada 3301 solved,    is cicada 3301 still alive,    is cicada 3301 still going on,    o que é cicada 3301 yahoo,    puzzles similar to cicada 3301,    similar to cicada 3301,    things similar to cicada 3301,    was cicada 3301 ever solved,    what does cicada 3301 do,    what does cicada 3301 mean,    what does cicada 3301 want,    what happened to cicada 3301,    what happened to cicada 3301 reddit,    what happens to cicada 3301 winners,    what is cicada 3301 purpose,    what is cicada 3301 puzzle,    what is cicada 3301 reddit,    what's cicada 3301,    when did cicada 3301 end,    when did cicada 3301 start,    when does cicada 3301 start,    where can i find cicada 3301,    where can i play cicada 3301,    where does cicada 3301 post,    where is cicada 3301,    where is the cicada 3301 puzzle,    where to find cicada 3301 puzzle,    where to play cicada 3301,    where to solve cicada 3301,    where to start cicada 3301,    where was cicada 3301 first posted,    who are cicada 3301,    who created cicada 3301,    who is cicada 3301 reddit,    who made cicada 3301,    who owns cicada 3301,    who runs cicada 3301,    who solved cicada 3301,    who started cicada 3301,    who won cicada 3301,    who's behind cicada 3301,    why cicada 3301,    will cicada 3301 ever be solved,    3301 cicada 2012,    3301 cicada 2014,    3301 cicada 2014 puzzle,    3301 cicada 2018,    3301 cicada 2019"    />
    <header>
    <h1 className="header-h1">The unsolved mystery of cicada 3301</h1>

    <div className="header-banner">
        <img src={logo1} alt="cicada 3301"/>
    </div>
   
    </header>
     
            <section className="content">
            <article>
            <h1>The biggest mystery of the internet CICADA 3301</h1>
                        <h2>Intro</h2> 
                        <p>Hope all of you have played puzzle games in you childhood even now you play such games in your mobile phones and in your colleges also.But do you know which is the most complex and the hardest puzzles ever uploaded into the internet.It is the Cicada 3301.It is one of the most hardest and the most complicated puzzles ever uploaded to the internet.It is also considered as one of the most mysterious puzzles on the internet.<br/>
                        <br/><br/>
                        <br/><br/>
                            Till now Cicada has uploaded 3 questions out of which 2 are solved and the third one is still unsolved.Today we will do an indepth exploration of all the three puzzles and the answer which are found already.</p>
                        <h2>The starting </h2>
                        <h3>Question no 1</h3>
                        <p>On 5th January 2012 on an image sharing and networking site called as 4chan an anonymous user posted an image which says we are hiring some highly intelligent individuals and to find them we have devised a test.Also is gave another hint that a message is hidden in this image and the person who finds the message will be selected.Just have a look at it.</p>
                           <p> <img src={msg1} alt="We are hiring some talented peoples over the earth and we have designed a question for them.A message is hidden in this pic the person who solves it will be selected for future programes" /></p><br/>
                        <p>At first no one understood but when the image was opened in a text editor there was a message in the ceaser cipher code at the last line of the image.Ceaser cipher is method of encrypting the text so that no one else can read it.<br/>
                            Deciphering the hidden message revealed a link which onclicked took to an image which at first sight looked normal.
                            <img src={img3} alt="Woops Just decoys this way.Looks like you can't guess how to guess the message out"  />
                            <br/>
                            The image does not give any information about the clue at the glance but if you look at the 2 words present there that is out and guess you can think what to do next.Outguess is an application a stegnographic application which aims to hide an entire file into an image.After outguessing the image we get a link and some quotes.Have a look below.
                            <br/>
                            <img src={img2} alt="The pic revealed after outguessing" />
                            <p>
                                Lets leave the quotes first and focus on the link present there.The link was of a subreddit post.The post was of a random user in which he uploaded not just one but 128 random text paragraphs.Neither the post had many images nor it contain any meaningful title nor any comments.So what was it.In the last posts there are 2 images which look simple but on outguessing those images we get huge lists.The list does not contain any hint but it contained warnings by CICADA.<br/>
                                The warning was that due to the popularity of the cicada many fake sites and images were also uploading so to stop them cicada embedded some hidden pgp signatures on the files received after outguessing those images which on verification confirms that it is directly from cicada and is not fake.So lets get back to the reddit post but nothing was found there for days until someone just noticed mayan numeral on the header of the post using which all the posts on the reddit post was solved.Those posts when combined gave a whole page which is directly taken from book 'THE MABINOGION'
                                Remember the quotes you found earlier by out guessing the images are nothing but the characters at a particular line.After finding all the characters it is converted to a sentence.Have a look below.
                                <br/><img src={img3} alt="call us at a number specified " />
                                <br/>
                                After calling at that number the thing relied was<br/>
                                <p>
                                    VERY GOOD <br/> YOU HAVE DONE WELL <br/>THERE ARE THREE PRIME NUMBERS ASSOCIATED WITH THE ORIGINAL FINAL .JPEG IMAGE<br/>3301 IS ONE OF THEM.<br/>YOU WILL HAVE TO FIND THE OTHER TWO.<br/>MULTIPLY ALL THREE NUMBERS TOGETHER AND ADD A .COM AT THE END TO FIND THE NEXT STEP<br/>GOODLUCK
                                </p>

                                It means the image you got in starting has three numbers.One of them is 3301 and two we have to find and multiply each other  to get the final answer.But these two numbers are nowhere to be found neither by outguessing nor by opening in a text editor.So what are these numbers.Actually these numbers are the dimensions of the image i.e. 509 by 503.
                                <br/>
                                So we have got all the three numbers and after multiplying we get 845145127 as the result and after adding a .com to it we get www.845145127.com.<br/>Clicking on the link the people were redirected to a  site where there is a countdown going on but nothing happened as it was finished.Also there was a logo of cicada there which on outguessing gives coordinates of 14 different locations across the earth.These locations were across whole earth and people had to moveout to find the locations and clue.
                                All the location yeild a logo of cicada with a QR code on it. All the 14 codes when scanned has a poem and some quotes written on it which was common in all the posts.<br/>
                                The poem leads us to a book and the quotes gives us a complete link.The link was of dark web with an extension of  .onion .The first few peoples who went to site were selected in the cicada group and after that the site was shut down with a message <br/>"WE WANT THE BEST NOT THE FOLLOWERS"
                                <br/>After that CICADA uploaded an image that confirms that it has got those highly intelligent people and also there will be more quests like this in future. But no one knows what happened to the people who got selected for this one.
                            </p>
                        </p>
                        <h3>Question no 2</h3>
                        <p>
                            Once again on the same day 5th January 2013 Cicada uploaded their second quest which started with a photo stating that the search for the intelligent people again starts.Check the image below.
                            <br/><img src={msg2} alt="the quest for the second round begins" />
                            <br/>
                            Outguessing the image leads us to a poem and some quotes.The poems leads to an book and the quotes help in finding the characters in those books. Arranging those characters from the quote gives us a meaningful url of dropbox which on clicking downloads some file and in those files there is also an music file the The Instar Emergence. Some analysts experimented on the music and converted it into an image which on outguessing.But this time the outguessed file had a large white space along with the hidden pgp signature.Detailed analysis found that the empty space was created using the space bar and tab bar.Converting those code into binary and then to alphbets leads us to a link.<br/>
                            That link leads us to a dark web page where the coordinates of 14 different locations were given. At all those 14 locations there were qr codes like the question no. 1 which on scanning leads to a dark web's website.Again the first few people to reach there are selected and then the site shuts down with a similar messsage as in first case.
                        </p>
                        <h2>Question no 3</h2>
                        <p>After round one and two now it is time for round 3.On 6th of January 2013 the third puzzle was released bu cicada.Have a look at it
                            <br/><img src={msg3} alt="the quest for third round begins" />
                            <br/>
                            Outguessing those images gave a poem and quotes whch lead to a book and with the quotes gives a link of dark web.As we progress we get a total of 5 dark web links.
                            These web links constitutes a total of 74 pages with some rule language which are of book Liber Primus.Decoding rule language is very hard as it is highly cryptic and complicated.
                            <br/>
                            Due to this complexcity out of 74 pages 58 pages are still unsolved.
                        </p>
                        <h2>The End</h2>
                         <p>
                             Since the third puzzle was never solved so the CICADA didnt uploaded the next puzzle.In 2016 it released another photo saying that after you solve the third puzzle you will get a way to next puzzle.Since then it was never solved.After some years of solving also many people gave up and now no one solves the question.
                               
                               
                         </p>
            </article>
            <div className="other">
                <div className="content1">
                  <Link to="/isro-aditya-l1/aditya-l1-isro-mission-to-conquer-the-sun">
                     <h4>
                        ISRO's mission to conquer the sun    
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/area-51/the-mystery-of-area-51-revealed">
                     <h4>
                        The mystery of area 51 revealed
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/amazon.com/unique-products-available-on-amazon">
                     <h4>
                        Unique products available on amazon.in
                      <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
           
            <div className="other">
                <div className="content1">
                  <Link to="create-a-blog/an-indepth-guide-on-how-to-make-a-blog">
                     <h4>
                        How to create a free blog
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/truecaller-truth/truecaller-business-model-and -truth-revealed">
                     <h4>
                         The truth of truecaller app
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/devil-sea/the-mystery-of-devil-sea">
                     <h4>
                        The unsolved mystery of devil sea
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/time-travel/the-mystery-of-time-travel-revealed">
                     <h4>
                         The time travel mystery revealed
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/earn-money-online/ultimate-guide-to-earn-money-in-2019">
                     <h4>
                         Simple steps to earn money online
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/sun-facts/what-if-the-sun-disappears">
                     <h4>
                         What if the sun disappears
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/fast-charger/fast-charging-technologies-explained">
                     <h4>
                        The principle of fast charging in smartphones
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/flat-earth/the-reality-of-flat-earth-society-debunked">
                     <h4>
                         The reality of flat earth society
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/smartphone-buying/ultimate-guide-to-purchase-smartphone">
                     <h4>
                         Ultimate guide to purchase a new smartphone
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/global-warming/innovative-technology-to-stop-global-warming">
                     <h4>
                        Innovation In Technologies to stop global warming
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/gps-working/indepth-guide-on-how-gps-works">
                     <h4>
                         Indepth guide on the working of GPS
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/pyramids-mystery/aliens-involvement-in-construction-of-pyramids">
                     <h4>
                        The alien involvement in construction of pyramids
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            
            <div className="other">
                <div className="content1">
                  <Link to="/laptop-buying/ultimate-laptop-buying-guide">
                     <h4>
                         The ultimate laptop buying guide             
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/moon-facts/what-if-moon-disappears">
                     <h4>
                         What if the moon disappears
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 

            <div className="other">
                <div className="content1">
                  <Link to="/isro-aditya-l1/aditya-l1-isro-mission-to-conquer-the-sun">
                     <h4>
                        ISRO's mission to conquer the sun    
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/area-51/the-mystery-of-area-51-revealed">
                     <h4>
                        The mystery of area 51 revealed
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/amazon.com/unique-products-available-on-amazon">
                     <h4>
                        Unique products available on amazon.in
                      <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>
                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/cicada-3301/the-unsolved-mystery-of-cicada-3301">
                     <h4>
                        The unsolved mystery of cicada 3301
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="create-a-blog/an-indepth-guide-on-how-to-make-a-blog">
                     <h4>
                        How to create a free blog
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/truecaller-truth/truecaller-business-model-and -truth-revealed">
                     <h4>
                         The truth of truecaller app
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/devil-sea/the-mystery-of-devil-sea">
                     <h4>
                        The unsolved mystery of devil sea
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/time-travel/the-mystery-of-time-travel-revealed">
                     <h4>
                         The time travel mystery revealed
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/earn-money-online/ultimate-guide-to-earn-money-in-2019">
                     <h4>
                         Simple steps to earn money online
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/sun-facts/what-if-the-sun-disappears">
                     <h4>
                         What if the sun disappears
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/fast-charger/fast-charging-technologies-explained">
                     <h4>
                        The principle of fast charging in smartphones
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/flat-earth/the-reality-of-flat-earth-society-debunked">
                     <h4>
                         The reality of flat earth society
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/smartphone-buying/ultimate-guide-to-purchase-smartphone">
                     <h4>
                         Ultimate guide to purchase a new smartphone
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/global-warming/innovative-technology-to-stop-global-warming">
                     <h4>
                        Innovation In Technologies to stop global warming
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/gps-working/indepth-guide-on-how-gps-works">
                     <h4>
                         Indepth guide on the working of GPS
                         <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/pyramids-mystery/aliens-involvement-in-construction-of-pyramids">
                     <h4>
                        The alien involvement in construction of pyramids
                        <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            
            <div className="other">
                <div className="content1">
                  <Link to="/laptop-buying/ultimate-laptop-buying-guide">
                     <h4>
                         The ultimate laptop buying guide             
                        <img src={robot} alt="robot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
            <div className="other">
                <div className="content1">
                  <Link to="/moon-facts/what-if-moon-disappears">
                     <h4>
                         What if the moon disappears
                         <img src={bat} alt="bot" style={{maxWidth:`70px`,height:`auto`}}/>

                     </h4>
                     </Link>
                </div>
            </div> 
         
</section> 
</Layout>
)}

export default IndexPage
